module.exports = __webpack_public_path__ + "img/1-5.9d4f336e.svg";